module.exports = __webpack_public_path__ + "img/christine-full.ee4561af.png";